import React from 'react';
import { motion } from 'framer-motion';
export function Process() {
  const steps = [{
    num: '01',
    name: 'Diagnosticar',
    desc: 'Evaluamos tu sitio web actual con el ICD™. Cinco dimensiones. Criterios objetivos. El resultado es un mapa preciso de qué está fallando y cuánto le está costando al negocio.',
    extra: 'A diferencia de una auditoría genérica, el ICD™ es un sistema propietario con criterios verificables. No es una opinión de diseño. Es un índice.',
    result: '✓ Sabes exactamente qué corregir en tu sitio web y por qué.'
  }, {
    num: '02',
    name: 'Construir',
    desc: 'Diseñamos y construimos tu sitio web basado en los datos del ICD™. Cada decisión de estructura, diseño y contenido tiene justificación en el diagnóstico. No en tendencias visuales.',
    result: '✓ Tu sitio web comunica lo que tu empresa vale.'
  }, {
    num: '03',
    name: 'Optimizar',
    desc: 'Medimos el ICD™ de tu nuevo sitio web. Comparamos contra el diagnóstico inicial. Identificamos las optimizaciones siguientes para mantener la brecha cerrada.',
    result: '✓ Tu sitio web mejora con el tiempo, no se queda estático.'
  }];
  return <section className="bg-carbon text-arena py-[72px] md:py-[120px]" data-id="element-352">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="mb-16 md:mb-[80px]" data-id="element-354">
          <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-4" data-id="element-355">
            CÓMO CONSTRUIMOS TU SITIO WEB
          </span>
          <h2 className="font-display text-[32px] md:text-[48px] font-bold text-arena leading-[1.1] max-w-[560px] mb-4" data-id="element-356">
            Sistema de Presencia de Alto Impacto™
          </h2>
          <p className="font-body text-[16px] md:text-[20px] text-arena/55 leading-[1.6] max-w-[520px]" data-id="element-357">
            Un proceso diseñado para construir sitios web que resuelvan brechas
            reales de comunicación, no sitios que simplemente se vean bien.
          </p>
        </motion.div>

        <div className="relative" data-id="element-358">
          <div className="hidden md:block absolute top-[24px] left-[10%] right-[10%] h-px bg-arena/15" data-id="element-359"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-360">
            {steps.map((step, idx) => <motion.div key={idx} className="relative z-10" initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.2
          }} transition={{
            duration: 0.4,
            ease: 'easeOut',
            delay: idx * 0.1
          }} data-id="element-361">
                <div className="bg-carbon inline-block pr-4 md:pr-0 md:bg-transparent mb-4 md:mb-6" data-id="element-362">
                  <span className="block font-body text-[11px] uppercase font-semibold text-azul tracking-widest" data-id="element-363">
                    {step.num}
                  </span>
                </div>
                <h3 className="font-display text-[24px] md:text-[28px] font-bold text-arena mb-4" data-id="element-364">
                  {step.name}
                </h3>
                {step.extra && <p className="font-body text-[14px] text-arena/55 leading-[1.6] max-w-[300px] mb-3 italic" data-id="element-365">
                    {step.extra}
                  </p>}
                <p className="font-body text-[15px] md:text-[16px] text-arena/55 leading-[1.6] max-w-[300px] mb-4" data-id="element-366">
                  {step.desc}
                </p>
                <p className="font-body text-[14px] text-verde font-medium" data-id="element-367">
                  {step.result}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}